import React, { useContext } from 'react'
import { Dropdown } from 'react-bootstrap'
import CustomDropdownToggle from '../../custom/CustomDropdownToggle'
import { useSelector } from 'react-redux'
import Icon from 'icons/Icon'
const CurrencyField = ({ formik, contextValue }) => {
  const { languageData } = useSelector(state => state.language)
  const { tenantDetails } = useContext(contextValue)
  const { values, setFieldValue, validateField, errors, touched } = formik
  const currenciesToShow = tenantDetails?.tenantConfig?.matchingCurrencies
  const hasError = errors?.currencyCode && touched?.currencyCode
  return (
    <Dropdown
      className='icon-right small-height'
      id='currencyCode'
    >
      <Dropdown.Toggle id='dropdown-basic2' as={CustomDropdownToggle} hasError={hasError}>
        <span>
          {tenantDetails?.tenantConfig?.allowedCurrencies?.find(
            (curr) => curr === values?.currencyCode
          ) || languageData?.selectCurrencyCode || 'Select Currency Code'}
        </span>
        <Icon name='drop-arrow' className='drop-arrow-icon' />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <div className='scrollDropdown'>
          <Dropdown.Item disabled>{languageData?.selectCurrencyCode || 'Select Currency Code'}</Dropdown.Item>
          {currenciesToShow?.map((curr) => (
            <Dropdown.Item
              key={curr}
              onClick={async () => {
                await setFieldValue('currencyCode', curr)
                validateField('currencyCode')
              }}
            >
              {curr}
            </Dropdown.Item>
          ))}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default CurrencyField
